import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-diffrent-type-of-report',
  templateUrl: './diffrent-type-of-report.component.html',
  styleUrls: ['./diffrent-type-of-report.component.scss']
})
export class DiffrentTypeOfReportComponent implements OnInit {
  visible = true;
  removable = true;
  selectable = true;
  selected_from_date: any = null;
  selected_to_date: any = null;
  selected_session: any = null;
  selected_sale_type: any = null;
  selected_report_option: any = null;
  session_list: any = [];
  selected_product_list: any = [];
  is_leakage_included = false;
  disable_checkbox: boolean = false;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  separatorKeysCodes: number[] = [ENTER, COMMA];
  booth_code_list = [];
  exclude_booth_code_list = [];
  entered_booth_code: any = null;
  entered_booth_code_for_exclude: any = null;
  zone_list: any;
  business_type_list: any;
  mor_route_list: any;
  eve_route_list: any;
  selected_zone_list: any = [];
  selected_business_type_list: any = [];
  selected_route_list: any = [];
  general_report_data: any = null;
  is_all_zone_selected = false;
  title: any;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.httpService.serveDataForGeneralReport().subscribe((data: any) => {
      console.log(data);
      this.general_report_data = data;
      this.session_list = data['session_data'];
      this.zone_list = data['zone_data'];
      this.business_type_list = data['business_type_data'];
      this.business_type_list.forEach(element => {
        this.selected_business_type_list.push(element.id);
      });
      this.mor_route_list = data['mor_route_data'];
      this.eve_route_list = data['eve_route_data'];
    }, (error) => {
      console.log(error);
    });
  }

  selectAllZonedCalled(event) {
    if (event['checked']) {
      this.is_all_zone_selected = true;
      this.zone_list.forEach(element => {
        this.selected_zone_list.push(element.id);
      });
    } else {
      this.is_all_zone_selected = false;
      this.selected_zone_list = [];
    }
    this.makeBoothCodeListCalled();
  }

  makeBoothCodeListCalled() {
    let zone_list = [];
    this.booth_code_list = [];
    this.selected_zone_list.forEach(element => {
      zone_list = zone_list.concat(this.general_report_data['zone_wise_booth'][element]);
    });
    let business_type_list = [];
    this.selected_business_type_list.forEach(element => {
      business_type_list = business_type_list.concat(this.general_report_data['business_type_wise_booth'][element]);
    });
    this.booth_code_list = zone_list.filter(v => business_type_list.indexOf(v) > -1);
  }

  removeBoothCalled(booth_value) {
    let index = this.booth_code_list.map((element) => {
      return element;
    }).indexOf(booth_value);
    this.booth_code_list.splice(index, 1);
  }

  removeBoothCalledForExclude(booth_value) {
    let index = this.exclude_booth_code_list.map((element) => {
      return element;
    }).indexOf(booth_value);
    this.exclude_booth_code_list.splice(index, 1);
  }

  checkBoxValue(value) {
    if (this.selected_product_list.includes(value)) {
      return true;
    } else {
      return false;
    }
  }

  addNewBoothCalled() {
    if (this.entered_booth_code !== null && this.entered_booth_code !== '') {
      this.booth_code_list.push(this.entered_booth_code.trim());
    }
    this.entered_booth_code = null;
  }

  addNewBoothCalledForExclude() {
    if (this.entered_booth_code_for_exclude !== null && this.entered_booth_code_for_exclude !== '') {
      this.exclude_booth_code_list.push(this.entered_booth_code_for_exclude.trim());
    }
    this.entered_booth_code_for_exclude = null;
  }

  productClearCalled() {
    this.selected_product_list = [];
  }

  boothclearCalled() {
    this.booth_code_list = [];
    this.selected_zone_list = [];
    this.selected_business_type_list = [];
    this.selected_route_list = [];
  }

  boothclearCalledForExclude() {
    this.exclude_booth_code_list = [];
  }

  productValueChanged(event, product_value) {
    this.document_file = null;
    if (event['checked']) {
      this.selected_product_list.push(product_value);
    } else {
      let index = this.selected_product_list.map((element) => {
        return element;
      }).indexOf(product_value);
      this.selected_product_list.splice(index, 1);
    }
  }

  zoneValueChanged(event, zone_value) {
    if (event['checked']) {
      this.selected_zone_list.push(zone_value);
      this.makeBoothCodeListCalled();
    } else {
      let index = this.selected_zone_list.map((element) => {
        return element;
      }).indexOf(zone_value);
      this.selected_zone_list.splice(index, 1);
      // for (let code of this.general_report_data['zone_wise_booth'][zone_value]) {
      //   let code_index = this.booth_code_list.map((element) => {
      //     return element;
      //   }).indexOf(zone_value);
      //   this.booth_code_list.splice(code_index, 1);
      // }
      this.makeBoothCodeListCalled();
    }
  }

  zoneCheckBoxValue(value) {
    if (this.selected_zone_list.includes(value)) {
      return true;
    } else {
      return false;
    }
  }

  businessTypeValueChanged(event, business_type_value) {
    if (event['checked']) {
      this.selected_business_type_list.push(business_type_value);
      this.makeBoothCodeListCalled();
    } else {
      let index = this.selected_business_type_list.map((element) => {
        return element;
      }).indexOf(business_type_value);
      this.selected_business_type_list.splice(index, 1);
      this.makeBoothCodeListCalled();
    }
  }

  businessTypeCheckBoxValue(value) {
    if (this.selected_business_type_list.includes(value)) {
      return true;
    } else {
      return false;
    }
  }

  routeValueChanged(event, route_value) {
    if (event['checked']) {
      this.selected_route_list.push(route_value);
      this.booth_code_list = Array.from(new Set(this.booth_code_list.concat(this.general_report_data['route_wise_booth'][route_value])));
    } else {
      let index = this.selected_route_list.map((element) => {
        return element;
      }).indexOf(route_value);
      this.selected_route_list.splice(index, 1);
      for (let code of this.general_report_data['route_wise_booth'][route_value]) {
        let code_index = this.booth_code_list.map((element) => {
          return element;
        }).indexOf(route_value);
        this.booth_code_list.splice(code_index, 1);
      }
    }
  }

  routeCheckBoxValue(value) {
    if (this.selected_route_list.includes(value)) {
      return true;
    } else {
      return false;
    }
  }

  checkDisabled() {
    if (this.selected_from_date == null || this.selected_to_date == null || this.selected_session == null || this.booth_code_list == null || this.selected_product_list.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  getClicked() {
    let data_dict = {
      'from_date': this.selected_from_date,
      'to_date': this.selected_to_date,
      'session_id': this.selected_session,
      'booth_code_list': this.booth_code_list,
      'exclude_booth_code_list': this.exclude_booth_code_list,
      'product_list': this.selected_product_list,
      'is_leakage_included': this.is_leakage_included
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveAdvanceReportInExcel(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      console.error(error);
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/octet-stream;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  getDocument() {
    return 'data:application/octet-stream;base64,' + this.document_file['excel'];
  }

  changeEvent() {
    this.document_file = null;
  }
  
  ngOnInit() {
  }

}
